export const environment = {
  production: true,
  paths: {
    // data: 'https://systest.tikschool.ir',
    data: ' https://sys.tikschool.ir'

  },
};
